import React from 'react';
import styled from '@emotion/styled';
import Image, { ImageProps } from 'src/components/Image';
import { MakePropertyNullable } from 'src/types/utils';
export type ProfileImageProps = MakePropertyNullable<ImageProps, 'src'>;
const ProfileImg = styled(Image)`
  object-fit: cover;
`;
export const defaultProfileImage = '/images/profile/imgProfile.png';
const ProfileImage: React.FC<ProfileImageProps> = ({
  src,
  ...props
}) => {
  if (src) {
    return <ProfileImg src={src} {...props} alt='profile image' supportImageSet={false} isBig={false} />;
  }
  return <ProfileImg src={defaultProfileImage} {...props} alt='profile image' data-sentry-element="ProfileImg" data-sentry-component="ProfileImage" data-sentry-source-file="index.tsx" />;
};
export default ProfileImage;